import React from 'react';
import { Box, IconButton, SxProps, TextField, Theme } from '@mui/material';
import { EsgSearchIcon } from 'assets';

interface DefaultSearchBarProps {
    searchValue: string;
    onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

const defaultSx = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '240px',
    height: '36px',
    borderRadius: '10px',
    border: '1px solid black',
};

export const DefaultSearchBar = ({
    searchValue,
    onSearchChange,
    placeholder = 'Search sites...',
    disabled,
    sx,
}: DefaultSearchBarProps) => (
    <Box sx={{ ...defaultSx, ...sx }}>
        <IconButton aria-label="Search" disabled={disabled}>
            <EsgSearchIcon />
        </IconButton>
        <TextField
            placeholder={placeholder}
            value={searchValue}
            onChange={onSearchChange}
            disabled={disabled}
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-start',
                border: 'none',
                '& input': {
                    padding: 0,
                    fontSize: '14px',
                },
                '& fieldset': {
                    border: 'none',
                },
            }}
            inputProps={{
                'aria-label': placeholder || 'Search',
            }}
        />
    </Box>
);